import { z } from 'zod'
import { makeFieldKeys, validateWithZodSchema } from '../../core/utils/utilities.ts'
import { TABLE_ACCOUNTS, TABLE_FUNDS, FIELD_KEY_SEPARATOR } from '../globals.ts'

const ALIAS_ACCOUNTS = `${TABLE_ACCOUNTS}${FIELD_KEY_SEPARATOR}` as const
const ALIAS_FUNDS = `${TABLE_FUNDS}${FIELD_KEY_SEPARATOR}` as const

const FIELD_ACCOUNTS_ID = `${ALIAS_ACCOUNTS}id` as const
const FIELD_ACCOUNTS_NAME = `${ALIAS_ACCOUNTS}name` as const
const FIELD_FUNDS_ID = `${ALIAS_FUNDS}id` as const
const FIELD_FUNDS_NAME = `${ALIAS_FUNDS}name` as const

const FIELD_INVESTED = 'invested'
const FIELD_INVESTED_FMT = 'invested_fmt'
const FIELD_COST_BASIS = 'cost_basis'
const FIELD_COST_BASIS_FMT = 'cost_basis_fmt'
const FIELD_REALIZED_VALUE = 'realized_value'
const FIELD_REALIZED_VALUE_FMT = 'realized_value_fmt'
const FIELD_UNREALIZED_VALUE = 'unrealized_value'
const FIELD_UNREALIZED_VALUE_FMT = 'unrealized_value_fmt'
const FIELD_MOIC = 'moic'
const FIELD_MOIC_FMT = 'moic_fmt'
const FIELD_FIRST_INVESTED = 'first_invested'
const FIELD_FIRST_INVESTED_FMT = 'first_invested_fmt'

export const InvestmentStatsEntrySchema = z
  .object({
    [FIELD_ACCOUNTS_ID]: z.string().nullish(),
    [FIELD_ACCOUNTS_NAME]: z.string().nullish(),
    [FIELD_FUNDS_ID]: z.array(z.string()).nullish(),
    [FIELD_FUNDS_NAME]: z.array(z.string()).nullish(),
    [FIELD_INVESTED]: z.number().nullish(),
    [FIELD_INVESTED_FMT]: z.string().nullish(),
    [FIELD_COST_BASIS]: z.number().nullish(),
    [FIELD_COST_BASIS_FMT]: z.string().nullish(),
    [FIELD_REALIZED_VALUE]: z.number().nullish(),
    [FIELD_REALIZED_VALUE_FMT]: z.string().nullish(),
    [FIELD_UNREALIZED_VALUE]: z.number().nullish(),
    [FIELD_UNREALIZED_VALUE_FMT]: z.string().nullish(),
    [FIELD_MOIC]: z.number().nullish(),
    [FIELD_MOIC_FMT]: z.string().nullish(),
    [FIELD_FIRST_INVESTED]: z.string().nullish(),
    [FIELD_FIRST_INVESTED_FMT]: z.string().nullish()
  })
  .strict()

const InvestmentStatsEntryFields = makeFieldKeys(InvestmentStatsEntrySchema)

export type InvestmentStatsEntry = z.infer<typeof InvestmentStatsEntrySchema>

function validateInvestmentStatsEntry(data: unknown): InvestmentStatsEntry {
  try {
    return validateWithZodSchema(InvestmentStatsEntrySchema, data, 'investment stats entry')
  } catch (error) {
    throw new Error(`Investment stats entry validation failed: ${error}`)
  }
}
